import React, { useState } from 'react';

import { DeviceComponent, DeviceComponentProps } from '../../../BaseDevice';
import GenericGamepadMenu from './GenericGamepadMenu';
// import GenericGamepadDialog from './GenericGamepadDialog';

const GenericGamepadUI = (props: DeviceComponentProps) => {
  const { onClose } = props;

  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  return (<>
    <GenericGamepadMenu {...props} setDialogOpen={setDialogOpen} />
    {/* {dialogOpen && <GenericGamepadDialog onClose={() => {
      // Close dialog - should we close menu too?
      setDialogOpen(false);
      onClose();
    }} />} */}
  </>);
};

export default GenericGamepadUI;